/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S10_Li2Inputs */

const tr_mesafeli_s10_li2 = /** @type {(inputs: Mesafeli_S10_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yalnızca Müşteri'nin kendi tenant'ı kapsamında Platform tarafından otomatik entegrasyon süreçlerinde kullanılır; insan personel tarafından okunamaz.`)
};

const en_mesafeli_s10_li2 = /** @type {(inputs: Mesafeli_S10_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is used by the Platform only within the Customer's own tenant in automatic integration processes; it cannot be read by human personnel.`)
};

const de_mesafeli_s10_li2 = /** @type {(inputs: Mesafeli_S10_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`werden ausschließlich im Rahmen des eigenen Tenants des Kunden von der Plattform in automatischen Integrationsprozessen verwendet; sie sind für menschliches Personal nicht lesbar.`)
};

const ru_mesafeli_s10_li2 = /** @type {(inputs: Mesafeli_S10_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`используются Платформой только в рамках собственного тенанта Клиента в автоматических процессах интеграции; они недоступны для чтения сотрудниками.`)
};

/**
* | output |
* | --- |
* | "is used by the Platform only within the Customer's own tenant in automatic integration processes; it cannot be read by human personnel." |
*
* @param {Mesafeli_S10_Li2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s10_li2 = /** @type {((inputs?: Mesafeli_S10_Li2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S10_Li2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s10_li2(inputs)
	if (locale === "de") return de_mesafeli_s10_li2(inputs)
	if (locale === "ru") return ru_mesafeli_s10_li2(inputs)
	return tr_mesafeli_s10_li2(inputs)
});